// This file is automatically generated. Do not edit manually.

import { ControlChartParentGroup } from "src/api/generated/postgres/db/types/public_/tables/controlChartParentGroup";
import { ChartGroupView } from "src/api/generated/postgres/db/types/public_/tables/chartGroupView";
import { DefectGroupStore_SummaryRecord } from "src/api/generated/spc/defectGroups/defectGroupStore";
import { IsoDateTimeString } from "src/types/dateTime";
import { DefectGroupService_ParetoDataPoint } from "src/api/generated/spc/defectGroups/defectGroupService";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DefectGroupApi {
	export async function getParentGroups(): Promise<Array<ControlChartParentGroup>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/defectGroups/getParentGroups",
			method: "POST",
			data: {},
		});
		return response as Array<ControlChartParentGroup>;
	}

	export async function getDefectGroups(args: { parentGroupId: number }): Promise<Array<ChartGroupView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/defectGroups/getDefectGroups",
			method: "POST",
			data: {
				parentGroupId: args.parentGroupId,
			},
		});
		return response as Array<ChartGroupView>;
	}

	export async function getSummaryRecords(args: {
		chartGroupId: number;
		recordCount?: number;
	}): Promise<Array<DefectGroupStore_SummaryRecord>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/defectGroups/getSummaryRecords",
			method: "POST",
			data: {
				chartGroupId: args.chartGroupId,
				recordCount: args.recordCount,
			},
		});
		return response as Array<DefectGroupStore_SummaryRecord>;
	}

	export async function getParetoData(args: {
		chartGroupIds: Array<number>;
		recordCount?: number | null | undefined;
		timeFrom?: IsoDateTimeString | null | undefined;
		timeTo?: IsoDateTimeString | null | undefined;
		groupChartsByName?: boolean;
	}): Promise<Array<DefectGroupService_ParetoDataPoint>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/defectGroups/getParetoData",
			method: "POST",
			data: {
				chartGroupIds: args.chartGroupIds,
				recordCount: args.recordCount,
				timeFrom: args.timeFrom,
				timeTo: args.timeTo,
				groupChartsByName: args.groupChartsByName,
			},
		});
		return response as Array<DefectGroupService_ParetoDataPoint>;
	}
}
